let initPrevState:any = [];

export const ADD_IDS = "ADD_IDS";

export function payment (prevState:any = initPrevState, action:any){
    if (action.type == ADD_IDS){
        return [...action.payload];
    }

    return prevState;
}